import { toast } from "react-toastify";
import {
  fetchPriceBookRequest,
  fetchPriceBookSuccess,
  fetchPriceBookFailure,
} from "./reducer";
import { GET_ALL_PRICEBOOK } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const getPriceBook =
  (first = 10, offset = 1) =>
  async (dispatch) => {
    dispatch(fetchPriceBookRequest());

    try {
      const response = await determineBaseUrlAndPerformApiCall(
        GET_ALL_PRICEBOOK(first, offset),
        "GET"
      );

      if (response?.error) {
        dispatch(fetchPriceBookFailure(response.error.message));
        toast.error(response.error.message);
      } else {
        dispatch(fetchPriceBookSuccess(response));
      }
    } catch (error) {
      dispatch(fetchPriceBookFailure("Something went wrong"));
      toast.error("Something went wrong");
    }
  };